/**
 * Keep in sync with the new-theme CSS token `--si-option-height` (currently 30px).
 * Virtual-scroll dropdowns assume a fixed item size; mismatches cause jitter/jumps.
 */
export const SI_VIRTUAL_OPTION_ITEM_SIZE_PX: number = 30;

